<template>
  <div class="br-scheduler">
    <template v-if="!submitted">
      <div class="br-scheduler__head">
        <div class="br-scheduler__agents">
          <div class="avatar avatar--circle">
            <img
              src="/img/avatars/dennis-chapham.jpg"
              alt="Dennis Chapham">
          </div>
        </div>
        <h2>Dennis Chapham</h2>
        <p>We'd love a quick opportunity to show you how Zenvoy<br>might fit your organization's engagement needs.</p>

        <div class="row">
          <div class="twelve columns">
            <button
              class="button button--block u-border-radius"
              @click.prevent="openCalendly">
              Schedule Demo
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import store from 'store'
import axios from 'axios'
import moment from 'moment-business-days'
import last from 'lodash/last'

export default {
  data: () => ({
    timeRange: [],
    bookings: [],
    formActive: 'form-1',
    sizeSelection: {
      options: {
        5000: 'Less than 5K',
        25000: '5K - 25K',
        50000: '25K - 50K',
        100000: '50K - 100K',
        250000: '100k - 250K',
        '> 500k': 'More than 500k'
      },
      ranges: [
        { value: 5000, key: '5000' },
        { value: 25000, key: '25000' },
        { value: 50000, key: '50000' },
        { value: 50001, key: '100000' },
        { value: 100000, key: '250000' },
        { value: 250001, key: '> 500k' }
      ]
    },
    submitted: false,
    isLoading: false,
    response: '',
    responseNoSched: '',
    model: {
      name: null,
      email: null,
      phone_number: null,
      organization_type: null,
      network_size: null,
      community_size: null,
      remarks: null,
      booked_at: null,
      time_slot: null,
      time_zone: 'PST'
    }
  }),
  computed: {
    getBookedDate () {
      return moment(`${this.model.booked_at} ${this.model.time_slot}`)
    },
    meetingDateFormatted () {
      return moment(this.getBookedDate).format('MMMM DD [at] h:mm A')
    },
    isWithSchedule () {
      if (this.model.booked_at && this.model.time_slot !== '' && this.model.time_zone !== '') {
        return true
      }
      return false
    }
  },
  watch: {
    'model.time_zone' () {
      this.model.time_slot = null
    }
  },
  async created () {
    window.moment = require('moment-timezone')
    this.bookings = await this.getBookings()

    const now = moment().add(1, 'day')

    if (now.weekday() > 0 && now.weekday() < 6) {
      this.model.booked_at = now().format('YYYY-MM-DD')
    } else {
      this.model.booked_at = moment().nextBusinessDay().format('YYYY-MM-DD')
    }

    if (this.hash) {
      const communitySize = store.get(this.hash).size

      this.model.community_size = last(this.sizeSelection
        .ranges
        .filter(range => range.value <= communitySize))
        .key
    }

    this.generateTimeRange()
  },
  methods: {
    openCalendly () {
      window.Calendly.showPopupWidget('https://calendly.com/zenvoy1/demo')
    },
    showPrevious (form) {
      this.formActive = 'form-1'
    },
    async getBookings () {
      const response = await axios.get(this.route('bookings'))

      return response.data.data
    },
    showNext () {
      if (this.formActive === 'form-2') {
        this.$validator.validateAll().then(result => {
          if (result) {
            axios.post(this.route('schedule-demo.submit'), this.model)

            this.submitted = true
          }
        })
        return
      }

      this.formActive = 'form-2'
    },
    isTimeDisabled (hour) {
      if (this.model.time_zone === 'PST') {
        return !(hour >= 900 && hour <= 1500) || (hour >= 1200 && hour <= 1230)
      }
      if (this.model.time_zone === 'CST') {
        return !(hour >= 1100 && hour <= 1700) || (hour >= 1400 && hour <= 1430)
      }

      return !(hour >= 1200 && hour <= 1800) || (hour >= 1500 && hour <= 1530)
    },
    generateTimeRange () {
      var time = moment()
        .hour(9)
        .minute(0)

      for (var x = 1; x <= 21; x++) {
        this.timeRange.push({
          slot: time.format('hh:mm A'),
          value: time.format('HH:mm'),
          hour: time.format('Hmm')
        })

        time = time.add(30, 'minutes')
      }
    }
  }
}
</script>
